module.exports = __webpack_public_path__ + "img/PPa.e608c612.png";